<template>
  <article class="flex w-full rounded-xl overflow-hidden" data-component="CardDiscoverPortrait">
    <AtomLink :url="url" class="flex flex-col w-full h-full" :class="{ 'bg-app-primary-1-red--fire-brick ': !theme, 'bg-white': theme === 'education' }">
      <MoleculePicture v-if="image" class="block w-full h-full bg-cover" :image="image" />
      <div class="c-card-discover-portrait-content p-6" :class="{ 'text-white': !theme, 'text-app-secondary-7-violet--purple-heart no-min-height': theme === 'education' }">
        <h5 v-if="category" class="text-sm md:text-xl font-semibold leading-tight">{{ category.title }}</h5>
        <h5 v-if="subtitle" class="text-sm md:text-xl font-semibold leading-tight">{{ subtitle }}</h5>
        <div
          v-if="(category || subtitle) && title"
          class="border-b-2 border-solid w-2/12 my-2 md:my-3"
          :class="{ 'border-app-primary-1-orange--bittersweet': !theme, 'border-app-secondary-9-blue--iris': theme === 'education' }"
        />
        <h4 v-if="title" class="text-sm md:text-xl leading-tight" :class="{ 'font-semibold': !theme }">{{ title }}</h4>
      </div>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
defineProps({
  image: {
    type: Object as PropType<Record<string, any>>,
    required: false,
    default: () => ({
      _xsUrl: '/images/fallback/612x522.png',
      _xsWidth: 612,
      _xsHeight: 522,
      _smUrl: '/images/fallback/352x300.png',
      _smWidth: 352,
      _smHeight: 300,
    }),
  },
  category: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  title: { type: String, required: true },
  subtitle: { type: String, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
  url: { type: String, required: true },
})
</script>

<style scoped>
.c-card-discover-portrait-content {
  min-height: 130px;
}
.c-card-discover-portrait-content.no-min-height {
  min-height: auto;
}
</style>
